import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
} from "@mui/material";
import React from "react";
import { back, eagle_icon } from "../../assets/images";
import CustomButton from "../CustomButton";
import { ChevronRightRounded } from "@mui/icons-material";

const PartnerUs = () => {
  const involvedText = [
    {
      id: 1,
      text: "Live in a remote or overpopulate environment where schooling is hard to come by",
    },
    {
      id: 2,
      text: "Are otherwise unable to attend other schools because of high costs",
    },
    {
      id: 3,
      text: " Are interested in engaging with course material in a practical, discussion-based format",
    },
    {
      id: 4,
      text: "Have a desire to learn more about the world and further their relationship with Christ",
    },
  ];

  return (
    <Box sx={{ width: "100vw" }}>
      <Container
        sx={{
          height: { md: "50vh" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "center", md: "space-between" },
          alignItems: "center",
          backgroundImage: `url(${back})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          pt: { xs: 5 },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "45%" },
            mb: { xs: 5 },
          }}
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            Partner with us
          </Typography>
          <Typography variant="h2" sx={{ width: "90%", mb: "1rem" }}>
            How to <span style={{ color: "#DB5430" }}>practically</span> partner{" "}
            <span style={{ color: "#DB5430" }}>with us</span>
          </Typography>
          <Typography>
            If you want to partner in a way that furthers our impact in
            comunities and touches the lives of many, consider partnering with
            us in the following ways:
          </Typography>
          <CustomButton sx={{ my: "1rem" }}>
            <Typography>Learn more</Typography>
            <ChevronRightRounded />
          </CustomButton>
        </Box>

        {/* Get involved Points */}
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            height: { md: "80%" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {involvedText.map((involve) => (
            <Card
              key={involve.id}
              sx={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background:
                  "linear-gradient(to right, #DB5430, rgba(112, 59, 20, 0))",
                padding: "0 5px 0 5px",
                borderRadius: 3,
                boxShadow: "none",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
                },
                mb: { xs: 2 },
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#fff",
                  width: 50,
                  height: 50,
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 100,
                  flexShrink: 0,
                }}
              >
                <CardMedia
                  component="img"
                  src={eagle_icon}
                  sx={{ width: 25, height: 19 }}
                />
              </Box>
              <CardContent>
                <Typography>{involve.text}</Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default PartnerUs;
